/** Labels and copy for Roles / Permissions admin screens. */

export const SYSTEM_ROLE_META = {
  management: { label: 'Management / FIC', hint: 'Leadership cockpit & oversight' },
  doctor: { label: 'Doctor / EMR', hint: 'Clinical consultation workspace' },
  receptiondesk: { label: 'Reception / Nursing', hint: 'Front desk, vitals, queues' },
  pharmacist: { label: 'Pharmacy / Lab', hint: 'Dispense & diagnostics' },
  admin: { label: 'Clinic Admin', hint: 'Full clinic administration' },
  super_admin: { label: 'Super Admin', hint: 'All screens and controls' },
  patient: { label: 'Patient portal', hint: 'Self-service campus patient' },
};

export const SYSTEM_ROLE_OPTIONS = [
  { v: 'management', l: 'Management / FIC portal' },
  { v: 'doctor', l: 'Doctor / EMR' },
  { v: 'receptiondesk', l: 'Reception / Nursing' },
  { v: 'pharmacist', l: 'Pharmacy / Lab' },
  { v: 'admin', l: 'Clinic Admin' },
  { v: 'super_admin', l: 'Super Admin (all screens)' },
];

export const MODULE_META = {
  Patients: 'Register and maintain patient records',
  Appointments: 'Book, view and confirm clinic visits',
  Clinical: 'Consultation, prescribe and referrals',
  Nursing: 'Vitals and nursing assistance',
  Laboratory: 'Lab orders and results entry',
  Roster: 'View and manage duty / OPD schedules',
  Reports: 'Operational and authentication reports',
  Administration: 'Users, roles, permissions, specialisations',
  Pharmacy: 'Pharmacy dispensing operations',
  Purchase: 'Purchase and procurement',
  Inventory: 'Stock and inventory control',
  Management: 'Leadership management cockpit',
  'Patient portal': 'Campus patient self-service',
};

export function systemRoleLabel(code) {
  return SYSTEM_ROLE_META[code]?.label || code || '—';
}

export function systemRoleHint(code) {
  return SYSTEM_ROLE_META[code]?.hint || '';
}

export function moduleHint(name) {
  return MODULE_META[name] || 'Feature access for this module';
}

export function coveragePct(checkedCount, total) {
  if (!total) return 0;
  return Math.round((checkedCount / total) * 100);
}
